webpackJsonp([169],{

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(72)(true);
// imports


// module
exports.push([module.i, ".vux-modal-open{overflow:hidden;position:fixed;width:100%}.vux-modal-open-for-container{overflow:hidden!important}", "", {"version":3,"sources":["/home/jenkins/workspace/HFS-FE_hfs-wechat.yunxiao.com_新版/node_modules/vux/src/styles/vux-modal.css"],"names":[],"mappings":"AAAA,gBACE,gBAAiB,AACjB,eAAgB,AAChB,UAAY,CACb,AACD,8BACE,yBAA2B,CAC5B","file":"vux-modal.css","sourcesContent":[".vux-modal-open {\r\n  overflow: hidden;\r\n  position: fixed;\r\n  width: 100%;\r\n}\r\n.vux-modal-open-for-container {\r\n  overflow: hidden!important;\r\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 200:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return USER_GET_WECHAT_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return USER_GET_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return USER_GET_INFO_BY_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return USER_SET_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return USER_SEND_PASSWORD_MSG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return USER_VERIFY_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return USER_RESET_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return USER_MATCH_STUDENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return USER_BIND_STUDENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return USER_GET_CAPTCHA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return USER_POST_TRACK_POINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return USER_GET_SCHOOL_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return USER_SET_SCHOOL_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return USER_DEL_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return USER_BIND_REAL_STUDENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return USER_ENROLL; });
// by szq on 2017-09-08
// wiki: http://wiki.iyunxiao.com/pages/viewpage.action?pageId=27986959

var USER_GET_WECHAT_CODE = 'USER_GET_WECHAT_CODE';
// 获取用户信息
var USER_GET_INFO = 'USER_GET_INFO';
var USER_GET_INFO_BY_CODE = 'USER_GET_INFO_BY_CODE';
var USER_SET_INFO = 'USER_SET_INFO';

// 发送找回密码短信
var USER_SEND_PASSWORD_MSG = 'USER_SEND_PASSWORD_MSG';
// 验证找回密码
var USER_VERIFY_PASSWORD = 'USER_VERIFY_PASSWORD';
// 重置找回密码
var USER_RESET_PASSWORD = 'USER_RESET_PASSWORD';

// 匹配学生档案信息
var USER_MATCH_STUDENTS = 'USER_MATCH_STUDENTS';
// 绑定学生档案
var USER_BIND_STUDENT = 'USER_BIND_STUDENT';
// 获取captcha code
var USER_GET_CAPTCHA = 'USER_GET_CAPTCHA';
// 上传微信埋点
var USER_POST_TRACK_POINT = 'USER_POST_TRACK_POINT';
// 获取用户学校配置
var USER_GET_SCHOOL_CONFIG = 'USER_GET_SCHOOL_CONFIG';
var USER_SET_SCHOOL_CONFIG = 'USER_SET_SCHOOL_CONFIG';
// 删除支付
var USER_DEL_PAYMENT = 'USER_DEL_PAYMENT';

// 虚拟学生绑定真实学生
var USER_BIND_REAL_STUDENT = 'USER_BIND_REAL_STUDENT';
var USER_ENROLL = 'USER_ENROLL';

/***/ }),

/***/ 27:
/***/ (function(module, exports) {

module.exports = {
  FilterSubjects: ['数', '语文', '英', '物理', '化', '生', '地', '历', '政', '思想品德', '思品', '理综', '理科综合', '文综', '文科综合'],
  ExactSubjects: ['数学', '语文', '英语', '物理', '化学', '生物', '地理', '历史', '政治', '政治', '政治', '理综', '理综', '文综', '文综'],
  SubjectTypeWen: {
    0: {
      name: '全科',
      shortName: '全'
    },
    1: {
      name: '语文',
      shortName: '语'
    },
    2: {
      name: '数学',
      shortName: '数'
    },
    3: {
      name: '英语',
      shortName: '英'
    },
    4: {
      name: '物理',
      shortName: '物'
    },
    5: {
      name: '化学',
      shortName: '化'
    },
    6: {
      name: '生物',
      shortName: '生'
    },
    7: {
      name: '政治',
      shortName: '政'
    },
    8: {
      name: '历史',
      shortName: '历'
    },
    9: {
      name: '地理',
      shortName: '地'
    },
    99: {
      name: '其他',
      shortName: '其他'
    }
  },
  LiveTeacherPhase: {
    1: '全部',
    2: '高中',
    3: '初中'
  },
  weekDay: {
    0: '周日',
    1: '周一',
    2: '周二',
    3: '周三',
    4: '周四',
    5: '周五',
    6: '周六'
  },
  couponType: {
    DISCOUNT: 1, // 支付红包
    TRY: 2 // 体验红包
  },
  useStudyCoin: {
    All: 1, // 使用全部学币抵扣
    Some: 2, // 使用指定数量学币
    None: 3 // 不使用学币
  },
  // 商品类型
  good: {
    MEMBERSHIP: 1, // 会员
    STUDYCOIN: 2, // 学币
    PRACTICE: 3, // 学习包
    LIVE_COURSE: 4, // 直播课程
    LIVE_COURSE_MEMBERSHIP: 5, // 爱云课畅听卡
    LIVE_COURSE_DEBIT_CARD: 6, // 直播课储值卡(直播卡)
    THIRD_EXAM_GOOD: 7, // 三方考试商品
    WRONG_COPIES_GOOD: 9, // 错题本
    POINT_MALL_GOOD: 10, // 积分商城
    FEED_GOOD: 11, // Feed栏目
    LIANBAO_TEHUI: 12, // 联报特惠
    EXAM_CTB: 21 // 错题本
  },
  couponTarget: {
    All: 0,
    Student: 1,
    Parent: 2
  },
  couponUseStatus: {
    Free: 1, // 可使用
    Pending: 2, // 正被占用
    Used: 3 // 已被使用
  },
  discountType: {
    FixValue: 1, // 固定数值
    FixRatio: 2 // 固定百分比
  },
  userType: {
    Student: 1,
    Parent: 2
  },
  videoType: {
    live: 1, // 看直播
    replay: 2 // 看回放
  },
  // 对应页面来源 redirect
  RedirectType: { // 当存在Path 时，不去取 name
    0: { // 个人中心 -- 绑定账号
      name: 'success@bind', // 对应路由内的name值
      path: '/bind/success',
      query: ['roleType', 'code'], // 可选，对应路由需要的参数
      register: true // 可选，为true时，登录页面显示注册按钮
    },
    1: { // 成绩查询
      name: 'report',
      path: '/report'
    },
    2: { // 个人中心 -- 我的课程
      name: 'myCourse',
      path: '/myCourse',
      register: true // 可选，为true时，登录页面显示注册按钮
    },
    3: { // 直播课 -- 所有课程
      path: '/list/all',
      name: 'courseList',
      register: true
    },
    4: { // 直播课 -- 免费课程
      path: '/list/free',
      register: true
    },
    5: { // 直播课 -- 往期精选
      path: '/list/past',
      register: true
    },
    6: { // 直播课程详情
      name: 'course',
      path: '/course',
      query: ['cid', 'ActivitiesReceive', 'activityId'],
      parent: true, // 直播详情进入登录时，仅展示家长端入口
      register: true
    },
    7: { // 课程主页
      name: 'mainCourse',
      path: '/mainCourse',
      register: true, // 可选，为true时，登录页面显示注册按钮
      query: ['cid']
    },
    8: { // 录播课程详情
      name: 'tapedDetail',
      path: '/tapedDetail',
      parent: true, // 录播详情进入登录时，仅展示家长端入口
      register: true, // 可选，为true时，登录页面显示注册按钮
      query: ['cid']
    },
    9: { // 录播视频 video
      name: 'tapedVideo',
      path: '/tapedVideo',
      register: true, // 可选，为true时，登录页面显示注册按钮
      query: ['cid', 'key']
    },
    10: { // 个人中心 -- 绑定成功,可优化掉
      name: 'success@bind',
      path: '/bind/success',
      register: true // 可选，为true时，登录页面显示注册按钮
    },
    11: { // 在线支付，已登录
      path: '/onlinePayment',
      register: true // 可选，为true时，登录页面显示注册按钮
    }
  },
  // 来源
  From: {
    // APP 邀请注册任务
    registerTask: 1
  },
  AnalysisListVisible: {
    // 可查看
    VISIBLE: 1,
    // 需购买
    BUY: 2
  },
  // 埋点统计相关
  TrackPoint: {
    // 统计数量, 以“1”开始
    quantity: {
      // 最新报告列表—成绩报告—考试成绩提分报告弹窗立即开通按钮
      reportDetail: 11,
      // 报告详情—购买能够获得权益弹窗—购买查看按钮
      paperAnalysis: 12,
      // 试题解析—只看错题按钮
      viewWrongItems: 13,
      // 试题解析—购买报告可查看错题弹窗—立即购买按钮
      buyAnalysis: 14,
      // 支付页-选择开通商品页单次报告立即支付按钮
      reportPayment: 15,
      // 支付成功—单次报告购买成功后查看报告按钮
      viewReportBuySueecss: 16,
      // 显示登录页面
      viewLogin: 1,
      // 显示历次报告列表页面
      viewReportList: 2,
      // 显示购买支付页
      viewPay: 4,
      // 支付成功-显示单次报告购买成功页
      reportBuySueecss: 5,
      // 成绩报告（未购买）
      clickBuyScore: 17,
      // 显示立即生成弹窗
      viewNowBuild: 21,
      // 显示报告详情页面
      viewReportDetail: 3,
      // 点击成绩分析样例中查看专属成绩分析
      clickViewAna: 18,
      // 报告详情底部查看我的专属成绩分析按钮
      clickViewAnaBottom: 19,
      // 显示购买能够获得权益弹窗
      viewBuyEquity: 22,
      // 显示只看错题弹窗
      viewOnlyMistakes: 23,
      // 分享出学生列表页,teacher代表教师端
      shareStudentListTeacher: 24,
      // 注册按钮
      registerButtonTeacher: 25,
      // 已注册按钮
      registeredButtonTeacher: 26,
      // 非微信环境注册并绑定学生按钮
      registerBindStudentsTeacher: 27,
      // 注册绑定成功页
      registerBindSuccessTeacher: 28,
      // 登录页
      loginPageTeacher: 29,
      // 登录按钮
      loginButtonTeacher: 30,
      // 微信环境注册并绑定学生按钮
      registerWxBindStudentsTeacher: 31,
      // 单科解析中查看专属分析悬浮按钮
      analysisBtn: 32,
      // 最新考试报告-考试成绩提分报告弹窗跳过按钮
      jumpReport: 33,
      // 查看单科时的悬浮按钮点击-购买能够获得权益弹窗跳过按钮
      getInterests: 34,
      // 成绩报告（已购买）
      reportHaveBuy: 35,
      // 最新考试报告热区
      hotBuyMembes: 36,
      // 最新考试报告底部点击立即开通按钮
      botBuyMembes: 37,
      // 会员购买页-会员购买确认支付按钮
      sureBuyMember: 38,
      // 支付页-选择开通商品选择单次报告
      singleReport: 39,
      // 支付页-选择开通商品页选择会员
      memberReport: 40,
      // 支付页-选择开通商品页会员立即支付按钮
      payMember: 41,
      // 支付成功-会员购买成功查看报告按钮
      viewMemberBuySueecss: 42,
      // 支付成功-会员购买成功页
      memberBuySueecss: 43,
      // 会员购买页，购买成功后查看报告按钮
      memberBuySueecssViewBtn: 44,
      // 直播课分享领折扣按钮
      shareDiscountBtn: 45,
      // 最新考试报告页
      newViewReportList: 46
    }
  }
};

/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugin_axios__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_plugin_checkResp__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_plugin_handleError__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_plugins_loading_index_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_plugins_toast_index_js__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vux_src_plugins_confirm_index_js__ = __webpack_require__(93);







__webpack_require__(89).polyfill();








Object(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5__plugin_axios__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6__assets_plugin_checkResp__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7__assets_plugin_handleError__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vux_src_plugins_loading_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vux_src_plugins_toast_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vux_src_plugins_confirm_index_js__["a" /* default */]);
sessionStorage.clear();
__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
  if (!sessionStorage.getItem('hfs-wechat-current-url')) {
    sessionStorage.setItem('hfs-wechat-current-url', document.URL);
  }
  next();
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App_vue___default.a }
});

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(303)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(419),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 303:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppHeader__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_AppHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts_lib_chart_bar__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts_lib_chart_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_echarts_lib_chart_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_lib_chart_radar__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_lib_chart_radar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_echarts_lib_chart_radar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts_lib_chart_pie__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts_lib_chart_pie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_echarts_lib_chart_pie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_component_tooltip__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_component_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_echarts_lib_component_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_component_dataZoom__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_component_dataZoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_echarts_lib_component_dataZoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_grid__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_echarts_lib_component_legend__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_echarts_lib_component_legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_echarts_lib_component_legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_echarts_lib_component_title__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_echarts_lib_component_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_echarts_lib_component_title__);

//
//
//
//
//
//
//



// todo: 视实际增减









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReportApp',
  components: { AppHeader: __WEBPACK_IMPORTED_MODULE_1__components_AppHeader___default.a },
  created: function created() {
    if (this.$store.getters.ifLogin && !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.state.user.userInfo).length) {
      this.$store.dispatch('USER_GET_INFO');
    }
    if (this.$store.getters.ifLogin) {
      this.$store.dispatch('USER_GET_SCHOOL_CONFIG');
    }
  }
});

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(306)
  __webpack_require__(307)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(309),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 306:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 307:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_header_index_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(32);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { XHeader: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_header_index_vue___default.a },
  data: function data() {
    return {
      isShow: true,
      title: '',

      showBack: true,

      showPayRecord: false,
      rightSlotStyle: {
        textDecoration: 'none',
        color: '#766864'
      },
      text: '',
      toName: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["e" /* mapState */])({
    vuexTitle: function vuexTitle(state) {
      return state.header.title;
    },
    userInfo: function userInfo(state) {
      return state.user.userInfo;
    }
  }), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({

    isParentUnShield: 'isParentUnShield'
  })),
  methods: {
    handleBack: function handleBack() {
      if (this.$route.query.isFromTrial) {
        this.$router.replace({ name: 'bindPhone', query: this.$route.query });
      } else {
        this.$router.replace({ name: 'reportList', query: this.$route.query });
      }
    }
  },
  watch: {
    $route: function $route(newRoute) {
      this.isShow = !newRoute.meta.hideHeader;
      this.title = '' || newRoute.meta.title;
      this.showPayRecord = newRoute.meta.showPayRecord || false;
      if (newRoute.name === 'reportList') {
        this.text = '历次考试';
        this.toName = 'reportHistory';
      } else if (newRoute.name === 'reportDetail' && this.userInfo.roleType == 2 && this.isParentUnShield) {
        this.text = '购买记录';
        this.toName = 'payRecord';
      }
      if (newRoute.name === 'reportList') {
        this.showBack = false;
      } else {
        this.showBack = true;
      }
    },
    vuexTitle: function vuexTitle(nv) {
      this.title = nv || this.$route.meta.title;
    }
  }
});

/***/ }),

/***/ 309:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-header"
  }, [(_vm.isShow) ? _c('XHeader', {
    attrs: {
      "left-options": {
        showBack: _vm.showBack,
        backText: '',
        preventGoBack: _vm.$route.name === 'reportHistory'
      }
    },
    on: {
      "on-click-back": _vm.handleBack
    }
  }, [_c('div', {
    staticClass: "app-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.showPayRecord) ? _c('router-link', {
    directives: [{
      name: "stat",
      rawName: "v-stat",
      value: ({
        id: _vm.text === '历次考试' ? (_vm.userInfo.roleType === 1 ? 'wxfwh_xs_bglb_zxksbg_lcks_click' : 'wxfwh_jz_bglb_zxksbg_lcks_click') : ''
      }),
      expression: "{id:text === '历次考试'?(userInfo.roleType ===1? 'wxfwh_xs_bglb_zxksbg_lcks_click':'wxfwh_jz_bglb_zxksbg_lcks_click'):''}"
    }],
    style: (_vm.rightSlotStyle),
    attrs: {
      "to": {
        name: _vm.toName
      }
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.text))]) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(43)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(45),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 38:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 39:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_safari_fix__ = __webpack_require__(84);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'toast',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_safari_fix__["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-toast"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowMask && _vm.show),
      expression: "isShowMask && show"
    }],
    staticClass: "weui-mask_transparent"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.currentTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-toast",
    class: _vm.toastClass,
    style: ({
      width: _vm.width
    })
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type !== 'text'),
      expression: "type !== 'text'"
    }],
    staticClass: "weui-icon-success-no-circle weui-icon_toast"
  }), _vm._v(" "), (_vm.text) ? _c('p', {
    staticClass: "weui-toast__content",
    style: (_vm.style),
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }) : _c('p', {
    staticClass: "weui-toast__content",
    style: (_vm.style)
  }, [_vm._t("default")], 2)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 41:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 419:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('AppHeader'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 42:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__x_dialog__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'confirm',
  components: {
    XDialog: __WEBPACK_IMPORTED_MODULE_0__x_dialog___default.a
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});

/***/ }),

/***/ 420:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(feConfig) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(80);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  base: feConfig.baseRoute + 'reportapp/',
  mode: 'history',
  scrollBehavior: function scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
  // 登录
  {
    path: '/login',
    name: 'login',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(516)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '登录' }
  }, {
    path: '/customer/service',
    name: 'CustomerService',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(151).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(517)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '咨询客服', hideHeader: true }
  },
  // 健康商城
  {
    path: '/health/mall',
    name: 'HealthMall',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(150).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(518)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '橙心易购', showPayRecord: false, hideHeader: true }
  },
  // 认领考试列表
  // {
  //   path: '/claim/exam/list',
  //   name: 'ClaimExamList',
  //   component: resolve => require(['@/views/ReportApp/components/ClaimExam/ClaimExamList'], resolve),
  //   meta: { title: '认领考试', showPayRecord: false }
  // },
  // 认领考试的试卷列表
  // {
  //   path: '/claim/exam/paper',
  //   name: 'ClaimExamPaper',
  //   component: resolve => require(['@/views/ReportApp/components/ClaimExam/ClaimExamPaper'], resolve),
  //   meta: { title: '根据答题卡认领', showPayRecord: false }
  // },
  {
    path: '/course/page',
    name: 'CoursePage',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(519)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '会员专享课程', hideHeader: true }
  }, {
    path: '/course/detail',
    name: 'CourseDetail',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(520)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '课程详情', hideHeader: true }
  }, {
    path: '/get-trial',
    name: 'GetTrial',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(98).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(521)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '领取试用' }
  }, {
    path: '/trial-qrcode',
    name: 'TrialQrcode',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(147).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(522)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '试用二维码' }
  },
  // 辅助运营 千万注册用户导航选择页面
  {
    path: '/registerednavigation',
    name: 'RegisteredNavigation',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(97).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(523)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '好分数学习助手', hideHeader: true }
  },
  // AI升学宝/AI 升学练习测试 报名页面
  {
    path: '/aisignup',
    name: 'AiSignUp',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(103).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(524)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '好分数学习助手', hideHeader: true }

  },
  // 找回密码
  {
    path: '/password/recover',
    name: 'findPassword',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(50).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(525)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '找回密码' }
  },
  // 重置密码
  {
    path: '/password/reset',
    name: 'resetPassword',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(130).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(526)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '重置密码' }
  },
  // 账号注册
  {
    path: '/register',
    name: 'registerAccount',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(35).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(527)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '账号注册', hideHeader: true }
  },
  // 非微信环境下账号注册成功页
  {
    path: '/register/success',
    name: 'registerSuccess',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(114).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(528)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '注册成功' }
  },
  // 服务条款
  {
    path: '/register/terms',
    name: 'registerTerms',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(154).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(529)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '服务条款' }
  },
  // 绑定学生
  {
    path: '/unbind',
    name: 'unBindStudent',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(57).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(530)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '完善学生信息' }
  },
  // 绑定学生
  {
    path: '/bind',
    name: 'bindStudent',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(70).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(531)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '绑定学生档案' }
  },
  // 通过证件号绑定学生
  {
    path: '/bind/id',
    name: 'bindStudentById',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(102).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(532)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '绑定学生' }
  },
  // 通过学校绑定学生
  {
    path: '/bind/school',
    name: 'bindStudentBySchool',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(533)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '绑定学生' }
  },
  // 授权码验证
  {
    path: '/bind/authorization',
    name: 'authorization',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(135).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(534)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '授权码验证' }
  },
  // idsp 北斗接入路由
  {
    path: '/reportEntrance',
    name: 'reportEntrance',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(149).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(535)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { hideHeader: true }
  },
  // 通过手机号绑定
  {
    path: '/bind/phone',
    name: 'bindPhone',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(80).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(536)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '绑定手机号' }
  },
  // 填写验证码
  {
    path: '/verification',
    name: 'fillVerifyCode',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(76).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(537)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '填写验证码' }
  },
  // 微信登录设置密码
  {
    path: '/bind/wechatPwd',
    name: 'bindWechatPwd',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(115).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(538)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '设置密码' }
  },
  // 最新考试报告
  // {
  //   path: '/report/list',
  //   name: 'reportList',
  //   component: resolve => require(['@/views/ReportApp/components/ReportList'], resolve),
  //   meta: { title: '最新考试报告', showPayRecord: true }
  // },
  // 联考报告
  // {
  //   path: '/unitedExamReport',
  //   name: 'unitedExamReport',
  //   component: resolve => require(['@/views/ReportApp/components/UnitedExamReport'], resolve),
  //   meta: { title: '联考报告', showPayRecord: false, hideHeader: true }
  // },
  // 历次考试
  // {
  //   path: '/report/history',
  //   name: 'reportHistory',
  //   component: resolve => require(['@/views/ReportApp/components/ReportHistoryList'], resolve),
  //   meta: { title: '报告列表' }
  // },
  // 会员购买
  {
    path: '/report/members',
    name: 'reportMembers',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(539)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '会员购买', showPayRecord: false, hideHeader: true }
  },
  // 报告详情
  // {
  //   path: '/report/detail',
  //   name: 'reportDetail',
  //   component: resolve => require(['@/views/ReportApp/components/ReportDetail'], resolve),
  //   meta: { title: '报告详情', showPayRecord: true }
  // },
  // 勋章墙
  // {
  //   path: '/report/detail/medalWall',
  //   name: 'reportMedalWall',
  //   component: resolve => require(['@/views/ReportApp/components/studentMedalWall'], resolve),
  //   meta: { title: '考试评价' }
  // },
  // 试题解析
  // {
  //   path: '/report/analysis',
  //   name: 'paperAnalysis',
  //   component: resolve => require(['@/views/ReportApp/components/PaperAnalysis'], resolve),
  //   meta: { title: '试题解析' }
  // },
  // 试题解析：查看错题
  // {
  //   path: '/report/analysis/wrong',
  //   name: 'wrongItemAnalysis',
  //   component: resolve => require(['@/views/ReportApp/components/WrongItemAnalysis'], resolve),
  //   meta: { title: '试题解析' }
  // },
  // 购买记录
  // {
  //   path: '/record',
  //   name: 'payRecord',
  //   component: resolve => require(['@/views/ReportApp/components/PayRecord'], resolve),
  //   meta: { title: '购买记录' }
  // },
  // 教师端分享页：注册列表
  {
    path: '/share/register',
    name: 'registerList',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(79).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(540)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '好分数帮家长', showPayRecord: false, hideHeader: true }
  },
  // 答题卡
  // {
  //   path: '/report/answerSheet',
  //   name: 'answerSheet',
  //   component: resolve => require(['@/views/ReportApp/components/AnswerSheet'], resolve),
  //   meta: { title: '答题卡', showPayRecord: true }
  // },
  // 购买页。注：由于支付目录的配置，需要在/report目录下才能发起支付。
  {
    path: '/report/pay',
    name: 'reportPayment',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(541)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '选择开通商品' }
  },
  // 购买完成后的提示分享页
  {
    path: '/report/pay-success',
    name: 'paymentSuccess',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(41).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(542)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '支付完成' }
  },
  // 购买完成后的分享页
  {
    path: '/share',
    name: 'reportShare',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(66).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(543)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '你查分了么' }
  },
  // 错题本售卖
  {
    path: '/report/wrongCopies',
    name: 'wrongCopies',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(544)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '填写信息' }
  }, {
    path: '/report/schoolWrongCopies',
    name: 'schoolWrongCopies',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(56).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(545)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '填写信息' }
  }, {
    path: '/report/schoolDeployCopies',
    name: 'schoolDeployCopies',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(47).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(546)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '填写信息' }
  }, {
    path: '/report/payWrongCopies',
    name: 'payWrongCopies',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(44).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(547)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '填写信息' }
  },
  // 错题本支付成功
  {
    path: '/wrongCopies/pay-success',
    name: 'wrongCopiesPaySuccess',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(146).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(548)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '支付成功', hideHeader: true }
  },
  // 新版ctb支付页
  {
    path: '/report',
    name: 'wrongCopiesIndex',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(152).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(549)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    children: [
    // 中转页
    {
      path: 'wrongCopiesTurn',
      name: 'wrongCopiesTurn',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(162).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(550)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: { title: '错题本详情', hideHeader: true }
    }, {
      path: 'newCtbDetail',
      name: 'newCtbDetail',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(32).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(551)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: { title: '错题本详情', hideHeader: true }
    }, {
      path: 'taocanDetail',
      name: 'taocanDetail',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(552)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: { title: '错题本详情', hideHeader: true }
    }, {
      path: 'new-pay-success',
      name: 'newPaySuccess',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(100).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(553)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: { title: '支付成功', hideHeader: true }
    }, {
      path: 'group-progress',
      name: 'groupProgress',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(67).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(554)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: { title: '拼团进度', hideHeader: true }
    }, {
      path: 'confirm',
      name: 'confirmInfo',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(101).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(555)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: { title: '确认订单', hideHeader: true }
    }, {
      path: '/newCtbSeniorOne',
      name: 'newCtbSeniorOne',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(133).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(556)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: { title: '高一错题本', hideHeader: true }
    }, {
      path: '/newCtbSeniorTwo',
      name: 'newCtbSeniorTwo',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(131).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(557)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: { title: '高二错题本', hideHeader: true }
    }, {
      path: '/newCtbSeniorThree',
      name: 'newCtbSeniorThree',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(132).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(558)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: { title: '高三错题本', hideHeader: true }
    }, {
      path: '/newCtbPayQrcode',
      name: 'newCtbPayQrcode',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(134).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(559)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: { title: '错题本详情', hideHeader: true }
    }, {
      path: 'confirmProduct',
      name: 'confirmProduct',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(83).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(560)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: { title: '确定商品', hideHeader: true }
    },
    // 新版错题本售卖
    {
      path: '/exam/ctb',
      name: 'ExamCtb',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(561)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: { title: '个性化错题本', hideHeader: true }
    },
    // 已购错题本
    {
      path: '/ctb/list',
      name: 'CtbList',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(99).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(562)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: { title: '已购错题本', hideHeader: true }
    },
    // 购买学币
    {
      path: '/study/coin/pay',
      name: 'StudyCoinPay',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(148).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(563)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: { title: '充值学币', hideHeader: true }
    }]
  },
  // 404
  {
    path: '*',
    name: 'notFound',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(138).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(564)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(7)))

/***/ }),

/***/ 421:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_modules_user__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_modules_exams__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_modules_bind__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_modules_header__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_modules_classes__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_modules_sale__ = __webpack_require__(430);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    modules: {
        header: __WEBPACK_IMPORTED_MODULE_5__modules_modules_header__["a" /* default */],
        user: __WEBPACK_IMPORTED_MODULE_2__modules_modules_user__["a" /* default */],
        exams: __WEBPACK_IMPORTED_MODULE_3__modules_modules_exams__["a" /* default */],
        bind: __WEBPACK_IMPORTED_MODULE_4__modules_modules_bind__["a" /* default */],
        classes: __WEBPACK_IMPORTED_MODULE_6__modules_modules_classes__["a" /* default */],
        sale: __WEBPACK_IMPORTED_MODULE_7__modules_modules_sale__["a" /* default */]
    }
}));

/***/ }),

/***/ 422:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(feConfig) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types_types_user__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_cookie__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_js_cookie__);




var _mutations, _actions;




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    isLogin: false,
    userInfo: {},
    paymentInfo: {},
    schoolConfig: {}
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types_types_user__["n" /* USER_SET_INFO */], function (state, payload) {
    state.userInfo = payload || {};
    var payloadObj = payload || {};
    if (payloadObj.roleType === 1) {
      payloadObj.appId = 'wxfwh_xs';
    } else if (payloadObj.roleType === 2) {
      payloadObj.appId = 'wxfwh_jz';
    } else {
      payloadObj.appId = '';
    }
    window.trackInfo = payloadObj;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types_types_user__["o" /* USER_SET_SCHOOL_CONFIG */], function (state, payload) {
    // 获取学校配置
    state.schoolConfig = payload || {};
  }), _mutations),
  actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__types_types_user__["i" /* USER_GET_WECHAT_CODE */], function (ctx, url) {
    if (url.indexOf('code=') === -1) {
      // location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
      //   feConfig.appId
      //   }&redirect_uri=${encodeURIComponent(url)}&response_type=code&scope=snsapi_userinfo#wechat_redirect`
    }
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__types_types_user__["f" /* USER_GET_INFO */], function (ctx) {
    return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].http.get('/v1/accounts/user-info').then(function (resp) {
      // debugger
      return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].checkResp(resp);
    }).then(function (data) {
      ctx.commit(__WEBPACK_IMPORTED_MODULE_3__types_types_user__["n" /* USER_SET_INFO */], data);
      return data;
    }).catch(function (err) {
      // 统一错误处理
      ctx.commit(__WEBPACK_IMPORTED_MODULE_3__types_types_user__["n" /* USER_SET_INFO */], null);
      throw err;
    });
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__types_types_user__["g" /* USER_GET_INFO_BY_CODE */], function (ctx, code) {
    return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].http.get('/v1/accounts/user-link', { params: { code: code } }).then(function (data) {
      ctx.commit(__WEBPACK_IMPORTED_MODULE_3__types_types_user__["n" /* USER_SET_INFO */], data);
      return data;
    }).catch(function (err) {
      ctx.commit(__WEBPACK_IMPORTED_MODULE_3__types_types_user__["n" /* USER_SET_INFO */], null);
      throw err;
    });
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__types_types_user__["m" /* USER_SEND_PASSWORD_MSG */], function (ctx, postData) {
    return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].http.post('/v1/be-proxy/v2/users/retrieving-msg-code-with-captcha', postData).then(function (resp) {
      return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].checkResp(resp);
    }).then(function (data) {
      return data;
    });
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__types_types_user__["p" /* USER_VERIFY_PASSWORD */], function (ctx, _ref) {
    var phoneNumber = _ref.phoneNumber,
        roleType = _ref.roleType,
        retrievingMsgCode = _ref.retrievingMsgCode;

    return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].http.post('/v1/be-proxy/v2/users/retrieving-msg-token', {
      phoneNumber: phoneNumber,
      roleType: roleType,
      retrievingMsgCode: retrievingMsgCode
    }).then(function (resp) {
      return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].checkResp(resp);
    }).then(function (data) {
      return data;
    });
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__types_types_user__["l" /* USER_RESET_PASSWORD */], function (ctx, _ref2) {
    var retrievingToken = _ref2.retrievingToken,
        password = _ref2.password;

    return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].http.put('/v1/be-proxy/v2/users/forgot-password', {
      retrievingType: 2,
      retrievingToken: retrievingToken,
      password: password
    }).then(function (resp) {
      return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].checkResp(resp);
    }).then(function (data) {
      return data;
    });
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__types_types_user__["j" /* USER_MATCH_STUDENTS */], function (ctx, _ref3) {
    var roleType = _ref3.roleType,
        studentName = _ref3.studentName,
        identityCode = _ref3.identityCode;

    return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].http.get('/v1/be-proxy/v2/users/matched-students', {
      params: { roleType: roleType, studentName: studentName, identityCode: identityCode }
    }).then(function (resp) {
      return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].checkResp(resp);
    }).then(function (data) {
      return data;
    });
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__types_types_user__["a" /* USER_BIND_REAL_STUDENT */], function (ctx, params) {
    return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].http.post('/v1/be-proxy/v2/native-users/bind-real-student', params).then(function (resp) {
      return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].checkResp(resp);
    }).then(function (data) {
      return data;
    });
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__types_types_user__["b" /* USER_BIND_STUDENT */], function (ctx, params) {
    return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].http.put('/v1/be-proxy/v2/users/bind-student', params).then(function (resp) {
      return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].checkResp(resp);
    }).then(function (data) {
      return data;
    });
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__types_types_user__["e" /* USER_GET_CAPTCHA */], function (ctx, params) {
    return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].http.get('/v1/be-proxy/v2/users/captcha', { params: params }).then(function (resp) {
      return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].checkResp(resp);
    }).then(function (data) {
      return data;
    });
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__types_types_user__["k" /* USER_POST_TRACK_POINT */], function (ctx, params) {
    return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].http.post('/v1/be-proxy/v2/track-point', params).then(function (resp) {
      return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].checkResp(resp);
    }).then(function (data) {
      return data;
    });
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__types_types_user__["h" /* USER_GET_SCHOOL_CONFIG */], function (ctx) {
    var schoolConfig = ctx.state.schoolConfig;
    if (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(schoolConfig).length) {
      return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].http.get('/v1/config/school').then(function (resp) {
        return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].checkResp(resp);
      }).then(function (data) {
        ctx.commit(__WEBPACK_IMPORTED_MODULE_3__types_types_user__["o" /* USER_SET_SCHOOL_CONFIG */], data);
        return data;
      }).catch(function (err) {
        // 统一错误处理
        ctx.commit(__WEBPACK_IMPORTED_MODULE_3__types_types_user__["o" /* USER_SET_SCHOOL_CONFIG */], null);
        throw err;
      });
    } else {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(schoolConfig);
    }
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__types_types_user__["c" /* USER_DEL_PAYMENT */], function (ctx, paymentId) {
    return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].http.delete('/v1/be-proxy/v2/payments/' + paymentId).then(function (resp) {
      return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].checkResp(resp);
    }).then(function (data) {
      return data;
    });
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__types_types_user__["d" /* USER_ENROLL */], function (ctx, params) {
    return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].http.post('/v1/messages/enroll', params).then(function (resp) {
      return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].checkResp(resp);
    }).then(function (data) {
      return { msg: '报名成功' };
    }).catch(function (err) {
      return err;
    });
  }), _actions),
  getters: {
    ifLogin: function ifLogin() {
      // 根据cookie判断；
      return !!__WEBPACK_IMPORTED_MODULE_5_js_cookie___default.a.get(feConfig.cookie);
    },

    // 屏蔽状态的设定 有三种状态，
    // 1.未登录与学生账号一致， 会员购买等不展示；
    // 2.家长账号但未配置屏蔽，会员购买等正常展示；
    // 3.家长账号且配置屏蔽， 会员购买等调整隐藏或显示已领取
    isShield: function isShield(state, getters, rootState) {
      return !getters.ifLogin || state.userInfo.roleType === 1;
    },
    isParentShield: function isParentShield(state) {
      return state.userInfo.roleType === 2 && state.schoolConfig.parentPay === 1;
    },
    isParentUnShield: function isParentUnShield(state) {
      return state.userInfo.roleType === 2 && state.schoolConfig.parentPay === 2;
    },
    currentUrl: function currentUrl() {
      return sessionStorage.getItem('hfs-wechat-current-url') || document.URL;
    },

    getSchoolConfig: function getSchoolConfig(state) {
      return function (examId) {
        // 判断examConfig存在,
        var examConfigs = state.schoolConfig && state.schoolConfig.examConfigs || [];
        var globalConfig = state.schoolConfig || {};

        if (!examId) return globalConfig;

        var config = examConfigs.find(function (g) {
          return Number(g.examId) === Number(examId);
        });
        // 如果有examId,优先使用examConfig,没有考试则使用全局配置
        var resultConfig = config || globalConfig;
        resultConfig.rankDegree = globalConfig.rankDegree;
        if (!resultConfig.score) {
          resultConfig.score = 2; // 默认为未屏蔽 2
        }
        return resultConfig || {};
      };
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(7)))

/***/ }),

/***/ 423:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_types_exams__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(1);


var _actions;




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    profile: {}
  },
  mutations: {},
  actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__types_types_exams__["b" /* EXAMS_GET_LIST */], function (ctx) {
    return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.get('/v1/exam-proxy/v3/3rdExam/3rd-list').then(function (resp) {
      return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].checkResp(resp);
    }).then(function (data) {
      return data;
    }).catch(function (err) {
      // 统一错误处理
      throw err;
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__types_types_exams__["a" /* EXAMS_GET_BE_LIST */], function (ctx) {
    return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.get('/v1/exam-proxy/v3/exam/list').then(function (resp) {
      return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].checkResp(resp);
    }).then(function (data) {
      return data;
    }).catch(function (err) {
      // 统一错误处理
      throw err;
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__types_types_exams__["c" /* GET_MEMBERS */], function (ctx) {
    // 获取是否是会员
    return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.get('/v1/be-proxy/v2/user-center/payment-info').then(function (resp) {
      return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].checkResp(resp);
    }).then(function (data) {
      return data;
    }).catch(function (err) {
      // 统一错误处理
      throw err;
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__types_types_exams__["d" /* GET_MEMBER_SHIPS */], function (ctx) {
    // 获取会员资格
    return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.get('/v1/be-proxy/v2/payments/goods-list').then(function (resp) {
      return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].checkResp(resp);
    }).then(function (data) {
      return data;
    }).catch(function (err) {
      // 统一错误处理
      throw err;
    });
  }), _actions),
  getters: {}
});

/***/ }),

/***/ 424:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EXAMS_GET_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EXAMS_GET_BE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_MEMBERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_MEMBER_SHIPS; });
//历史考试列表
var EXAMS_GET_LIST = "EXAMS_GET_LIST";
var EXAMS_GET_BE_LIST = "EXAMS_GET_BE_LIST";
//获取会员信息
var GET_MEMBERS = "GET_MEMBERS";
//获取会员资格
var GET_MEMBER_SHIPS = "GET_MEMBER_SHIPS";

/***/ }),

/***/ 425:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_types_bind__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types_types_user__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(1);



var _actions;





/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    info: {}
  },
  mutations: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2__types_types_bind__["h" /* BIND_SET_VERIFY_ACCOUNT */], function (state, payload) {
    state.info = payload || {};
  }),
  actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__types_types_bind__["i" /* BIND_VERIFY_ACCOUNT */], function (ctx, _ref) {
    var code = _ref.code;

    var params = { code: code
      // 过滤多余数据
      // if (studentId && studentId != 'f71dd2a06faa555e' && studentId !== 'null' && studentId !== 'undefined') {
      //   params.studentId = studentId
      // }
      /**
       * 登陆微信
       * http://wiki.iyunxiao.com/pages/viewpage.action?pageId=27986959#hfs-wechat%E5%B8%90%E5%8F%B7%E4%BD%93%E7%B3%BBAPI-%E7%99%BB%E5%BD%95%E5%BE%AE%E4%BF%A1%EF%BC%88%E6%A0%B9%E6%8D%AEcode%E8%8E%B7%E5%8F%96cookie%E7%AD%89%E5%B8%90%E5%8F%B7%E4%BF%A1%E6%81%AF%EF%BC%89
       */
    };return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].http.get('/v1/accounts/user-link', { params: params }).then(function (resp) {
      return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].checkResp(resp, {});
    }).then(function (data) {
      data.account = data.loginName || '';
      ctx.commit(__WEBPACK_IMPORTED_MODULE_2__types_types_bind__["h" /* BIND_SET_VERIFY_ACCOUNT */], data);
      return data;
    }).catch(function (err) {
      // 统一错误处理
      ctx.commit(__WEBPACK_IMPORTED_MODULE_2__types_types_bind__["h" /* BIND_SET_VERIFY_ACCOUNT */], null);
      throw err;
    });
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__types_types_bind__["e" /* BIND_LOGIN_ACCOUNT */], function (ctx, _ref2) {
    var loginName = _ref2.loginName,
        password = _ref2.password,
        roleType = _ref2.roleType,
        code = _ref2.code;

    return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].http.put('/v1/accounts/user-link', {
      loginName: loginName,
      password: password,
      roleType: roleType,
      code: code
    }).then(function (resp) {
      return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].checkResp(resp);
    }).then(function (data) {
      ctx.commit(__WEBPACK_IMPORTED_MODULE_3__types_types_user__["n" /* USER_SET_INFO */], data);
      return data;
    }).catch(function (err) {
      // 统一错误处理
      ctx.commit(__WEBPACK_IMPORTED_MODULE_3__types_types_user__["n" /* USER_SET_INFO */], null);
      throw err;
    });
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__types_types_bind__["b" /* BIND_BY_STUDENT_ID */], function (ctx, params) {
    return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].http.post('/v1/accounts/native-users/bind-students', params).then(function (resp) {
      return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].checkResp(resp);
    }).then(function (data) {
      return data;
    }).catch(function (err) {
      throw err;
    });
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__types_types_bind__["c" /* BIND_CHECK_ACCOUNT */], function (ctx, _ref3) {
    var account = _ref3.account,
        roleType = _ref3.roleType;

    return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].http.get('/v1/be-proxy/v2/users/matched-users', {
      params: { account: account, roleType: roleType }
    }).then(function (resp) {
      return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].checkResp(resp);
    }).then(function (data) {
      return data;
    });
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__types_types_bind__["g" /* BIND_SEND_REGISTER_MSG */], function (ctx, postData) {
    return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].http.post('/v1/be-proxy/v2/native-users/verification-msg-with-captcha', postData).then(function (resp) {
      return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].checkResp(resp);
    }).then(function (data) {
      return data;
    });
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__types_types_bind__["f" /* BIND_REGISTER_ACCOUNT */], function (ctx, _ref4) {
    var phoneNumber = _ref4.phoneNumber,
        password = _ref4.password,
        verificationCode = _ref4.verificationCode,
        code = _ref4.code,
        roleType = _ref4.roleType;

    var verificationMsgToken = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
      phoneNumber: phoneNumber,
      password: password,
      verificationCode: verificationCode,
      roleType: roleType
    });
    return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].http.post('/v1/accounts/users-without-student', {
      code: code,
      roleType: roleType,
      verificationType: 2,
      deviceType: 4,
      verificationMsgToken: verificationMsgToken
    }).then(function (resp) {
      return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].checkResp(resp);
    }).then(function (data) {
      ctx.commit(__WEBPACK_IMPORTED_MODULE_3__types_types_user__["n" /* USER_SET_INFO */], data);
      return data;
    }).catch(function (err) {
      // 统一错误处理
      ctx.commit(__WEBPACK_IMPORTED_MODULE_3__types_types_user__["n" /* USER_SET_INFO */], null);
      throw err;
    });
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__types_types_bind__["a" /* BIND_BY_BEROUTE */], function (ctx, _ref5) {
    var phoneNumber = _ref5.phoneNumber,
        password = _ref5.password,
        verificationCode = _ref5.verificationCode,
        roleType = _ref5.roleType;

    var verificationMsgToken = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
      roleType: roleType,
      phoneNumber: phoneNumber,
      password: password,
      verificationCode: verificationCode
    });
    return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].http.post('/v1/accounts/users-without-wechat', {
      roleType: roleType,
      verificationType: 2,
      deviceType: 4,
      verificationMsgToken: verificationMsgToken
    }).then(function (resp) {
      return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].checkResp(resp);
    }).then(function (data) {
      ctx.commit(__WEBPACK_IMPORTED_MODULE_3__types_types_user__["n" /* USER_SET_INFO */], data);
      return data;
    }).catch(function (err) {
      // 统一错误处理
      ctx.commit(__WEBPACK_IMPORTED_MODULE_3__types_types_user__["n" /* USER_SET_INFO */], null);
      throw err;
    });
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__types_types_bind__["d" /* BIND_DELETE_ACCOUNT */], function (ctx, _ref6) {
    var code = _ref6.code;

    return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].http.delete('/v1/accounts/user-link', { params: { code: code } }).then(function (resp) {
      return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].checkResp(resp);
    }).then(function (data) {
      ctx.commit(__WEBPACK_IMPORTED_MODULE_2__types_types_bind__["h" /* BIND_SET_VERIFY_ACCOUNT */], data);
      return data;
    }).catch(function (err) {
      // 统一错误处理
      // ctx.commit(TypesUser.USER_SET_INFO, null);
      throw err;
    });
  }), _actions)
});

/***/ }),

/***/ 426:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return BIND_VERIFY_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return BIND_SET_VERIFY_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BIND_LOGIN_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BIND_CHECK_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return BIND_SEND_REGISTER_MSG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BIND_REGISTER_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BIND_DELETE_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BIND_BY_STUDENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BIND_BY_BEROUTE; });
// wiki: http://wiki.iyunxiao.com/pages/viewpage.action?pageId=27986959

// 验证微信账号是否已绑定并获取cookie
var BIND_VERIFY_ACCOUNT = 'BIND_VERIFY_ACCOUNT';
var BIND_SET_VERIFY_ACCOUNT = 'BIND_SET_VERIFY_ACCOUNT';
// 登录以绑定微信账号
var BIND_LOGIN_ACCOUNT = 'BIND_LOGIN_ACCOUNT';
// 注册账号查重
var BIND_CHECK_ACCOUNT = 'BIND_CHECK_ACCOUNT';
// 发送注册验证码
var BIND_SEND_REGISTER_MSG = 'BIND_SEND_REGISTER_MSG';
// 注册并绑定微信账号
var BIND_REGISTER_ACCOUNT = 'BIND_REGISTER_ACCOUNT';
// 解绑微信账号
var BIND_DELETE_ACCOUNT = 'BIND_DELETE_ACCOUNT';
// 由student_id绑定学生
var BIND_BY_STUDENT_ID = 'BIND_BY_STUDENT_ID';
// be路由下注册
var BIND_BY_BEROUTE = 'BIND_BY_BEROUTE';
// 仅登录不绑定微信
// export const BIND_ONLY_LOGIN_ACCOUNT = 'BIND_ONLY_LOGIN_ACCOUNT';

/***/ }),

/***/ 427:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_types_header__ = __webpack_require__(428);



/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    title: ''
  },
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__types_types_header__["a" /* HEADER_SET_TITLE */], function (state, newTitle) {
    state.title = newTitle || '';
  })
});

/***/ }),

/***/ 428:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HEADER_SET_TITLE; });
var HEADER_SET_TITLE = 'HEADER_SET_TITLE';

/***/ }),

/***/ 429:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    // 当前关注的学生信息（可能是登录 或 注册）
    targetStudent: {}
  },
  actions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, 'CLASS_GET_TARGET_STUDENT', function CLASS_GET_TARGET_STUDENT(_ref, _ref2) {
    var commit = _ref.commit;
    var secret = _ref2.secret,
        studentId = _ref2.studentId,
        type = _ref2.type;

    // 面向教师端分享页的注册
    var TYPE_TEACHER_SHARE = 1;
    // 面向学生端注册邀请：
    var TYPE_REGISTER_TASK = 2;
    if (type === TYPE_TEACHER_SHARE) {
      /**
       * 获取班级学生列表(主要含账户绑定情况)
       * http://wiki.iyunxiao.com/pages/viewpage.action?pageId=137921145#hfs-wechat%E7%8F%AD%E7%BA%A7API-%E8%8E%B7%E5%8F%96%E7%8F%AD%E7%BA%A7%E5%AD%A6%E7%94%9F%E5%88%97%E8%A1%A8
      */
      return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get('/v1/classes/students', { params: { secret: secret } }).then(function (resp) {
        return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].checkResp(resp);
      }).then(function (data) {
        if (data) {
          var targetStudent = data.students.find(function (s) {
            return s.id === studentId;
          });
          commit('CLASS_SET_TARGET_STUDENT', targetStudent);
        }
      });
    } else if (type === TYPE_REGISTER_TASK) {
      /**
       * 根据加密邀请信息获取学生基本信息
       * http://wiki.iyunxiao.com/pages/viewpage.action?pageId=147260976#id-%E5%AD%A6%E7%94%9F%E4%BF%A1%E6%81%AFAPI-V2-%E6%A0%B9%E6%8D%AE%E5%8A%A0%E5%AF%86%E9%82%80%E8%AF%B7%E4%BF%A1%E6%81%AF%E8%8E%B7%E5%8F%96%E5%AD%A6%E7%94%9F%E5%9F%BA%E6%9C%AC%E4%BF%A1%E6%81%AF
       */
      return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get('/v1/be-proxy/v2/mapi/students/basic-info', { params: { secret: secret } }).then(function (resp) {
        return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].checkResp(resp);
      }).then(function (data) {
        commit('CLASS_SET_TARGET_STUDENT', data);
      });
    } else return console.log('类型错误');
  }),
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, 'CLASS_SET_TARGET_STUDENT', function CLASS_SET_TARGET_STUDENT(state, payload) {
    state.targetStudent = payload || {};
  })
});

/***/ }),

/***/ 43:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 430:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_types_sale__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        orderInfo: {
            data: {
                paymentId: '',
                contact: {
                    telephone: '',
                    wechat: ''
                }
            },
            params: {
                phone: '',
                name: '',
                grade: '',
                class: '',
                schoolName: ''
            }
        }
    },
    mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__types_types_sale__["b" /* SET_SALE_WARONG_COPIES */], function (state, payload) {
        state.orderInfo = payload || {};
    }),
    actions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__types_types_sale__["a" /* SALE_WARONG_COPIES */], function (ctx, params) {
        return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post('/v1/payments/cuoti-member', params).then(function (resp) {
            return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].checkResp(resp);
        }).then(function (data) {
            ctx.commit(__WEBPACK_IMPORTED_MODULE_1__types_types_sale__["b" /* SET_SALE_WARONG_COPIES */], { data: data, params: params });
            return data;
        }).catch(function (err) {
            // 统一错误处理
            ctx.commit(__WEBPACK_IMPORTED_MODULE_1__types_types_sale__["b" /* SET_SALE_WARONG_COPIES */], {
                data: {
                    paymentId: '',
                    contact: {
                        telephone: '',
                        wechat: ''
                    }
                },
                params: {
                    phone: '',
                    name: '',
                    grade: '',
                    class: '',
                    schoolName: ''
                }
            });
            throw err;
        });
    })
});

/***/ }),

/***/ 431:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SALE_WARONG_COPIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_SALE_WARONG_COPIES; });
var SALE_WARONG_COPIES = 'SALE_WARONG_COPIES';

var SET_SALE_WARONG_COPIES = 'SET_SALE_WARONG_COPIES';

/***/ }),

/***/ 432:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(feConfig) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_enum__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_enum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__constants_enum__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_cookie__);






var instance = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  withCredentials: true
});

instance.interceptors.request.use(function (config) {
  var url = config.url;
  var urlArry = url.split('/') || [];
  var toPath = [].concat([''], urlArry.slice(2)).join('/');
  if (urlArry.length && urlArry[1] === 'idspProxy') {
    config.url = '' + feConfig.api.idsp + toPath;
  } else {
    config.url = '' + feConfig.api.base + url;
  }
  return config;
});

var INVALID_COOKIE = 1003;
instance.interceptors.response.use(function (response) {
  if (response && (INVALID_COOKIE === response.data.code || 3001 === response.data.code)) {
    __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.remove(feConfig.cookie, { domain: '.yunxiao.com' });
    location.href = feConfig.baseUrl + '/reportapp/login';
    // location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${feConfig.appId}&redirect_uri=${encodeURIComponent(url)}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
  }
  return response.data;
}, function (err) {
  if (err.response) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err.response.data);
  }
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject({ code: 1024, message: err.message });
});

function axios(options) {
  var cookie = null;
  if (options.cookie) {
    cookie = options.cookie.key + '=' + options.cookie.value;
    delete options.cookie;
  }
  var instance = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
    timeout: 4000
  }, options, cookie ? { headers: { 'Cookie': cookie } } : {}));
  return instance;
}

function plugin(Vue) {
  if (plugin.installed) {
    return;
  }
  Vue.http = instance;
  Vue.axios = axios;
  Object.defineProperty(Vue.prototype, '$http', { value: instance });
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(7)))

/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_prevent_body_scroll__ = __webpack_require__(86);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_prevent_body_scroll__["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});

/***/ }),

/***/ 45:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-x-dialog",
    class: {
      'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.maskTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-mask",
    style: (_vm.maskStyle),
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.hide($event)
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.dialogTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    class: _vm.dialogClass,
    style: (_vm.dialogStyle)
  }, [_vm._t("default")], 2)])], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 46:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-confirm"
  }, [_c('x-dialog', {
    attrs: {
      "dialog-class": _vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',
      "mask-transition": _vm.maskTransition,
      "dialog-transition": _vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,
      "hide-on-blur": _vm.hideOnBlur,
      "mask-z-index": _vm.maskZIndex
    },
    on: {
      "on-hide": function($event) {
        _vm.$emit('on-hide')
      }
    },
    model: {
      value: (_vm.showValue),
      callback: function($$v) {
        _vm.showValue = $$v
      },
      expression: "showValue"
    }
  }, [(!!_vm.title) ? _c('div', {
    staticClass: "weui-dialog__hd",
    class: {
      'with-no-content': !_vm.showContent
    }
  }, [_c('strong', {
    staticClass: "weui-dialog__title"
  }, [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), (_vm.showContent) ? [(!_vm.showInput) ? _c('div', {
    staticClass: "weui-dialog__bd"
  }, [_vm._t("default", [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])], 2) : _c('div', {
    staticClass: "vux-prompt"
  }, [_c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg),
      expression: "msg"
    }],
    ref: "input",
    staticClass: "vux-prompt-msgbox",
    attrs: {
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.msg)
    },
    on: {
      "touchend": _vm.setInputFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.msg = $event.target.value
      }
    }
  }, 'input', _vm.getInputAttrs()))])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__ft"
  }, [(_vm.showCancelButton) ? _c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_default",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm._onCancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText || '取消'))]) : _vm._e(), _vm._v(" "), (_vm.showConfirmButton) ? _c('a', {
    staticClass: "weui-dialog__btn",
    class: ("weui-dialog__btn_" + _vm.confirmType),
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm._onConfirm
    }
  }, [_vm._v(_vm._s(_vm.confirmText || '确定'))]) : _vm._e()])], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var UNAUTHORIZED = 2001;
var checkResp = function checkResp(resp) {
  if (resp && (resp.code === 0 || resp.code === 1 || resp.code === UNAUTHORIZED)) {
    return resp.data;
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(resp);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.checkResp = checkResp;
    Object.defineProperty(Vue.prototype, '$checkResp', { value: checkResp });
  }
});

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.handleError = function (err, msg) {
      if (typeof arguments[0] === 'string') {
        err = { msg: arguments[0] };
      }
      Vue.$vux.toast.show({
        text: err.msg || err.message || msg || '请求失败',
        type: 'text',
        position: 'bottom'
      });
    };
    Object.defineProperty(Vue.prototype, '$handleError', { value: Vue.handleError });
  }
});

/***/ }),

/***/ 49:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});

/***/ }),

/***/ 51:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-loading_toast vux-loading",
    class: !_vm.text ? 'vux-loading-no-text' : ''
  }, [_c('div', {
    staticClass: "weui-mask_transparent"
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-toast",
    style: ({
      position: _vm.position
    })
  }, [_c('i', {
    staticClass: "weui-loading weui-icon_toast"
  }), _vm._v(" "), (_vm.text) ? _c('p', {
    staticClass: "weui-toast__content"
  }, [_vm._v(_vm._s(_vm.text || '加载中')), _vm._t("default")], 2) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(67)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)


module.exports = Component.exports


/***/ }),

/***/ 67:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 68:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_object_assign__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return __WEBPACK_IMPORTED_MODULE_0_object_assign___default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});

/***/ }),

/***/ 69:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-header"
  }, [_c('div', {
    staticClass: "vux-header-left"
  }, [_vm._t("overwrite-left", [_c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm._leftOptions.showBack),
      expression: "_leftOptions.showBack"
    }],
    staticClass: "vux-header-back",
    on: {
      "click": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "preventDefault")) { return null; }
      }, _vm.onClickBack]
    }
  }, [_vm._v(_vm._s(typeof _vm._leftOptions.backText === 'undefined' ? '返回' : _vm._leftOptions.backText))])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm._leftOptions.showBack),
      expression: "_leftOptions.showBack"
    }],
    staticClass: "left-arrow",
    on: {
      "click": _vm.onClickBack
    }
  })])]), _vm._v(" "), _vm._t("left")], 2), _vm._v(" "), (!_vm.shouldOverWriteTitle) ? _c('h1', {
    staticClass: "vux-header-title",
    on: {
      "click": function($event) {
        _vm.$emit('on-click-title')
      }
    }
  }, [_vm._t("default", [_c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.title),
      expression: "title"
    }]
  }, [_vm._v(_vm._s(_vm.title))])])])], 2) : _vm._e(), _vm._v(" "), (_vm.shouldOverWriteTitle) ? _c('div', {
    staticClass: "vux-header-title-area"
  }, [_vm._t("overwrite-title")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "vux-header-right"
  }, [(_vm.rightOptions.showMore) ? _c('a', {
    staticClass: "vux-header-more",
    on: {
      "click": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "preventDefault")) { return null; }
      }, function($event) {
        _vm.$emit('on-click-more')
      }]
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("right")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = {
  api: {
    base: 'https://hfs-wechat-be.yunxiao.com',
    idsp: 'https://open.yunxiao.com/tpgw/auth',
    timeout: 20000
  },
  baseRoute: '/official/',
  // appId: 'wxa16ab844bcc07624',
  appId: 'wx03bbc392f0b75e2c',
  baseUrl: 'https://hfs-wechat.yunxiao.com/official',
  cookie: 'hfs-wechat-be-session-id',
  download: 'https://hfs-wechat.yunxiao.com/official/download',
  cross: {
    yltPage: 'https://m2.yunxiao.com/v2/collegeRecommend.html' // 育路通院校推荐h5页
  }
};

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(38)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(39),
  /* template */
  __webpack_require__(40),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(49)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)


module.exports = Component.exports


/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(41)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)


module.exports = Component.exports


/***/ }),

/***/ 90:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[301]);


// WEBPACK FOOTER //
// official/static/js/reportApp.3387ad3beae0bab0c03a.js